import React, { forwardRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const PrintTemplate = forwardRef(({ deliveryPoints, printerType }, ref) => {
  return (
    <div ref={ref}>
      {printerType === 'a4' ? (
        // A4 Format: 8 labels per page (2 columns × 4 rows)
        <>
          {(() => {
            const pages = [];
            for (let i = 0; i < deliveryPoints.length; i += 8) {
              const pageDeliveries = deliveryPoints.slice(i, i + 8);
              pages.push(
                <div
                  key={`page-${i}`}
                  style={{
                    width: '210mm',
                    height: '297mm',
                    pageBreakAfter: i + 8 < deliveryPoints.length ? 'always' : 'auto',
                    fontFamily: 'Montserrat, sans-serif',
                    padding: '8mm',
                    boxSizing: 'border-box',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gridTemplateRows: 'repeat(4, 1fr)',
                    gap: '6mm',
                    width: '100%',
                    height: '100%'
                  }}>
                    {pageDeliveries.map((dp) => (
                      <div
                        key={dp.id}
                        style={{
                          border: '2px solid #B1336E',
                          padding: '4mm',
                          boxSizing: 'border-box',
                          position: 'relative',
                          backgroundColor: 'white',
                          borderRadius: '3mm',
                          display: 'flex',
                          flexDirection: 'column'
                        }}
                      >
                        <p style={{ 
                          color: '#B1336E', 
                          fontSize: '18px', 
                          fontWeight: 'bold',
                          margin: '0 0 2mm 0'
                        }}>
                          ID: {dp.id}
                        </p>
                        <p style={{ 
                          color: '#1e293b', 
                          fontSize: '13px',
                          fontWeight: '600',
                          margin: '0 0 1.5mm 0',
                          lineHeight: '1.2'
                        }}>
                          {dp.recipient_name}
                        </p>
                        {dp.product && (
                          <p style={{ 
                            color: '#475569', 
                            fontSize: '10px',
                            margin: '0 0 1.5mm 0',
                            lineHeight: '1.2'
                          }}>
                            {dp.product}
                          </p>
                        )}
                        {dp.user_name && (
                          <p style={{ 
                            color: '#B1336E', 
                            fontSize: '9px',
                            fontWeight: '600',
                            margin: '0 0 1.5mm 0',
                            lineHeight: '1.2'
                          }}>
                            Vendedor: {dp.user_name}
                          </p>
                        )}
                        {dp.distric && (
                          <p style={{ 
                            color: '#475569', 
                            fontSize: '10px',
                            fontWeight: '500',
                            margin: '0 0 1.5mm 0',
                            lineHeight: '1.2'
                          }}>
                            {dp.distric}
                          </p>
                        )}
                        <p style={{ 
                          color: '#475569', 
                          fontSize: '9px',
                          margin: '0',
                          paddingRight: '28mm',
                          lineHeight: '1.3'
                        }}>
                          {dp.address}
                        </p>
                        <div style={{
                          position: 'absolute',
                          bottom: '4mm',
                          right: '4mm',
                          padding: '1.5mm',
                          backgroundColor: 'white',
                          borderRadius: '2mm'
                        }}>
                          <QRCodeCanvas
                            value={dp.tracking_code}
                            size={75}
                            level="H"
                            includeMargin={false}
                          />
                          </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            }
            return pages;
          })()}
        </>
      ) : (
        // Thermal Format: 80mm width, continuous roll
        <div style={{ fontFamily: 'Montserrat, sans-serif' }}>
          {deliveryPoints.map((dp, index) => (
            <div
              key={dp.id}
              style={{
                width: '80mm',
                minHeight: '60mm',
                border: '2px solid #B1336E',
                padding: '4mm',
                boxSizing: 'border-box',
                backgroundColor: 'white',
                marginBottom: '5mm',
                pageBreakAfter: index < deliveryPoints.length - 1 ? 'always' : 'auto',
                pageBreakInside: 'avoid',
                borderRadius: '3mm'
              }}
            >
              <div style={{ textAlign: 'center', marginBottom: '3mm' }}>
                <QRCodeCanvas
                  value={dp.tracking_code}
                  size={80}
                  level="H"
                  includeMargin={false}
                />
              </div>
              <p style={{ 
                color: '#B1336E', 
                fontSize: '18px', 
                fontWeight: 'bold',
                margin: '0 0 2mm 0',
                textAlign: 'center'
              }}>
                ID: {dp.id}
              </p>
              <p style={{ 
                color: '#1e293b', 
                fontSize: '13px',
                fontWeight: '600',
                margin: '0 0 2mm 0'
              }}>
                {dp.recipient_name}
              </p>
              {dp.product && (
                <p style={{ 
                  color: '#475569', 
                  fontSize: '10px',
                  margin: '0 0 1mm 0'
                }}>
                  {dp.product}
                </p>
              )}
              {dp.user_name && (
                <p style={{ 
                  color: '#B1336E', 
                  fontSize: '9px',
                  fontWeight: '600',
                  margin: '0 0 1mm 0'
                }}>
                  Vendedor: {dp.user_name}
                </p>
              )}
              {dp.distric && (
                <p style={{ 
                  color: '#475569', 
                  fontSize: '10px',
                  fontWeight: '500',
                  margin: '0 0 1mm 0'
                }}>
                  {dp.distric}
                </p>
              )}
              <p style={{ 
                color: '#475569', 
                fontSize: '9px',
                margin: '0'
              }}>
                {dp.address}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
});

PrintTemplate.displayName = 'PrintTemplate';

export default PrintTemplate;